import React from "react";

const ChevronLeft = () => {
  return (
    <svg
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      className="ChevronLeftSvgIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.75 10.5L5.25 7L8.75 3.5"
      />
    </svg>
  );
};

export default ChevronLeft;
